
<div inView (inView)="onAppear($event)" class="container section-gap">
  <div class="row" *ngIf="config.layout == 'right'">
    <div class="col-lg-6 col-sm-12 col-xs-12">
      <kla-title [position]="'left'" [lineConfig]="lineConfig" [config]="config" [showFooter]="false"></kla-title>
    </div>
    <div class="col-lg-6 col-sm-12 col-xs-12 chart-holder" #panel>
      <div *ngIf="!chart" class="row chart spinner-container">
        <div class="chart-position cm-spinner"></div>
      </div>
      <div *ngIf="chart" class="row chart">
        <kla-highchart class="chart-position" [config]="chart"
          [attr.role]="config?.chartAltText ? 'img' : null"
          [attr.aria-label]="config?.chartAltText || null"></kla-highchart>
      </div>
    </div>
    <div class="col-lg-6 col-sm-12 col-xs-12 offset-lg-6">
      <div class="footer-paragraph" *ngIf="config?.footer">
        <app-dynamic-content
          [contentId]="'venn-highchart-footer'"
          [htmlContent]="config.footer">
        </app-dynamic-content>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="config.layout == 'left'">
    <div class="col-lg-6 col-sm-12 col-xs-12 chart-holder" #panel>
      <div *ngIf="!chart" class="row chart spinner-container">
        <div class="chart-position cm-spinner"></div>
      </div>
      <div *ngIf="chart" class="row chart" inView (inView)="onAppear($event)">
        <kla-highchart class="chart-position" [config]="chart"
          [attr.role]="config?.chartAltText ? 'img' : null"
          [attr.aria-label]="config?.chartAltText || null"></kla-highchart>
      </div>
    </div>
    <div class="col-lg-6 col-sm-12 col-xs-12">
      <kla-title [position]="'right'" [lineConfig]="lineConfig" [config]="config" [showFooter]="false"></kla-title>
    </div>
    <div class="col-lg-6 col-sm-12 col-xs-12">
      <div class="footer-paragraph" *ngIf="config?.footer">
        <app-dynamic-content
          [contentId]="'venn-highchart-footer'"
          [htmlContent]="config.footer">
        </app-dynamic-content>
      </div>
    </div>
  </div>


  <div class="row" *ngIf="config.layout == 'full-width'">
    <div class="col-lg-12">
      <kla-title [position]="'full-width'" [lineConfig]="lineConfig" [config]="config" [showFooter]="false"></kla-title>
    </div>
    <div class="col-12 below-chart-holder" #panel>
      <div *ngIf="!chart" class="row chart spinner-container">
        <div class="chart-position cm-spinner"></div>
      </div>
      <div *ngIf="chart" class="row chart" inView (inView)="onAppear($event)">
        <kla-highchart class="chart-position" [config]="chart"
          [attr.role]="config?.chartAltText ? 'img' : null"
          [attr.aria-label]="config?.chartAltText || null"></kla-highchart>
      </div>
    </div>
    <div class="col-12">
      <div class="footer-paragraph" *ngIf="config?.footer">
        <app-dynamic-content
          [contentId]="'venn-highchart-footer'"
          [htmlContent]="config.footer">
        </app-dynamic-content>
      </div>
    </div>
  </div>
</div>